import styled from "styled-components";

import { StyledTableCell, StyledTableRow } from "@/styles/components";

export const StyledTableExpandableCell = styled(StyledTableCell)`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const StyledTableExpandedRow = styled(StyledTableRow)`
    background-color: var(--color-primary-extra-light);
`;
